module.exports = __webpack_public_path__ + "static/img/1_5_3.f0f77db5.jpg";